import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.product.$urlSegment';
import { CONTENT_CAP_PADDED } from '~/ui-rocco/pages/detail-shared';
import { SectionHead } from '~/ui-rocco/pages/detail-shared/SectionHead';
import { SimilarProductsRowContent } from './spec-accordion/SimilarProductsRowContent';

/**
 * (04) THE CATEGORY — the rest of the category, under the same head the range
 * gets. Out of the accordion for the same reason: a one-line row label was
 * doing the work of a section title.
 *
 * Desktop only. Mobile keeps `SimilarProductsSection`, whose standalone
 * treatment already reads as its own block on a narrow screen.
 */
export const MoreInCategorySection = () => {
    const { primaryCategory } = useLoaderData<typeof loader>();
    const category = primaryCategory?.PrettyTitle;

    if (!category) return null;

    return (
        <section className="bg-ground max-md:px-6 md:px-[3rem]">
            <div className={CONTENT_CAP_PADDED}>
                <SectionHead
                    lead="More in"
                    subject={category}
                    subjectLink={primaryCategory?.Link}
                    standfirst={`Everything else in ${category}, from every supplier on ArchiPro.`}
                />

                <div className="max-md:mt-8 md:mt-[4rem]">
                    <SimilarProductsRowContent />
                </div>
            </div>
        </section>
    );
};
